
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SalesInvoiceFromSalesOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"salesInvoiceFromSalesOrderInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesInvoiceFromSalesOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesInvoiceFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerInvoiceDocumentDefault"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerSalesInvoiceDefaultFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"middleName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mailshotRecipient"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveAcknowledgements"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveConformityCertificates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveDataSheets"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveDeliveryNotes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveDispatchEmails"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveInvoiceDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receivePaymentReceipts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveProformaInvoiceDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveQuotationDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveStatementDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveCreditDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveOverdueAccount"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1138}};
    doc.loc.source = {"body":"#import 'graphql/fragments/salesLedger/SalesInvoiceFragment.graphql'\n#import 'graphql/fragments/customer/CustomerSalesInvoiceDefaultFragment.graphql'\n\nmutation SalesInvoiceFromSalesOrder($input: salesInvoiceFromSalesOrderInput!) {\n  salesInvoiceFromSalesOrder(input: $input) {\n    clientMutationId\n    result {\n      ...SalesInvoiceFragment\n      customer {\n        customerInvoiceDocumentDefault {\n          ...CustomerSalesInvoiceDefaultFragment\n        }\n        contacts {\n          id\n          concurrencyVersion\n          name {\n            fullName\n            title\n            firstName\n            middleName\n            lastName\n          }\n          email\n          mailshotRecipient\n          receiveAcknowledgements\n          receiveConformityCertificates\n          receiveDataSheets\n          receiveDeliveryNotes\n          receiveDispatchEmails\n          receiveInvoiceDocuments\n          receivePaymentReceipts\n          receiveProformaInvoiceDocuments\n          receiveQuotationDocuments\n          receiveStatementDocuments\n          receiveCreditDocuments\n          receiveOverdueAccount\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('graphql/fragments/salesLedger/SalesInvoiceFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('graphql/fragments/customer/CustomerSalesInvoiceDefaultFragment.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SalesInvoiceFromSalesOrder"] = oneQuery(doc, "SalesInvoiceFromSalesOrder");
        
